import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleConfigComponentProps } from '../../IRuleType.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.LengthRange}`;

export function LengthRangeRuleComponent(props: IRuleConfigComponentProps) {
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.min`}
        label="Lunghezza minima"
        help="La lunghezza inserita si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.min`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
      <FormItem
        name={`${fieldName}.max`}
        label="Lunghezza massima"
        help="La lunghezza inserita si considera inclusa."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.max`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
